import { Modal } from 'antd'
import deleteRamsSigning from '../Services/delete'

export default () => (dispatch) => {

  Modal.confirm({
    title: `Are you sure to delete this ramsSigning?`,
    content: 'This action cannot be undone',
    okText: 'Yes',
    width: 400,
    onOk: () => dispatch(deleteRamsSigning()),
  })

}
